import { render, staticRenderFns } from "./userUnauthorizedAppleMusicMessage.vue?vue&type=template&id=0efd500c&"
import script from "./userUnauthorizedAppleMusicMessage.vue?vue&type=script&lang=js&"
export * from "./userUnauthorizedAppleMusicMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports